export default __webpack_public_path__ + "static/d3l2-florian-valeye-0ab4579fce031a0b073792c2e89c9493.jpg";